import { render, staticRenderFns } from "./travel-prevention-request.vue?vue&type=template&id=de51badc&scoped=true&"
import script from "./travel-prevention-request.vue?vue&type=script&lang=js&"
export * from "./travel-prevention-request.vue?vue&type=script&lang=js&"
import style0 from "./travel-prevention-request.vue?vue&type=style&index=0&id=de51badc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de51badc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
